export default function(params) {
  var self = this;

  self.defaults = {
    style: {}
  };

  self.config = _.extend({}, self.defaults, params);
  self.emitter = new Emitter();
  self.presented = false;

  self.present = function() {
    if(self.raiseWarnings() || self.presented) return;
    self.appendViewer();
    self.presented = true;
    self.emitter.emit('presented');
  };

  self.appendViewer = function() {
    self.$viewer = $('<img/>', { class: 'image-preview', id:'image-fullscreen', src: self.config.src });
    self.$viewer.css(self.config.style);
    self.$viewer.click(function(){ self.fullscreen() });
    self.config.$container.append(self.$viewer);
  };

  self.fullscreen = function() {
    self.$viewer[0].requestFullscreen();
  };

  self.destroy = function() {
    self.$viewer.remove();
    self.emitter.emit('destroy');
  };

  self.hide = function() {
    self.$viewer.hide();
    self.emitter.emit('hide');
    self.config.$container.css({display: '', 'justify-content': ''});
  };

  self.show = function() {
    self.$viewer.show();
    self.config.$container.css({display: 'flex', 'justify-content': 'center'});
    self.emitter.emit('show');
  };

  self.raiseWarnings = function() {
    if(!self.config.src) {
      console.warn('Image Media Renderer: Must provide image src: { src: "my-image-src" }');
      return true;
    } else {
      return false;
    }
  };

  return self;
}

